import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReadOnlyViewIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ReadOnlyView",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.22 18.66c-.83 0-1.5-.67-1.5-1.5V6.53c0-.4.32-.73.73-.74h14.2c.36 0 .66.27.72.62l2.09-1.84H5.44c-.9 0-1.63.73-1.63 1.63v17.38l5.59-4.91h-.19Zm14.16-1.5c0 .83-.67 1.5-1.49 1.5h-5.4l-4.61 4.05h10.2c.47 0 .86.37.86.84v3.28c0 .16-.12.29-.27.29H10.12a.29.29 0 0 1-.29-.29v-2.29l-3.24 2.84.11.1c.3.36.75.57 1.23.57h17.74c.9 0 1.63-.73 1.63-1.63V9.16l-3.93 3.43.02 4.56Zm6.36-13.17a.97.97 0 0 0-1.38-.13c-.02.01-.03.03-.05.05L2.36 26.6c-.42.34-.48.96-.13 1.38.01.01.02.03.04.04.19.22.46.34.75.34.25 0 .5-.08.69-.25L29.64 5.42c.42-.34.49-.96.14-1.38a.12.12 0 0 0-.05-.05Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 23.57c-.63 0-1.14-.51-1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H8.71a1.14 1.14 0 1 1 0-2.28h17.14c1.89 0 3.43 1.54 3.43 3.43v17.14c0 .63-.51 1.14-1.14 1.14ZM22.43 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V8.71a1.14 1.14 0 1 1 2.28 0v17.14c0 .63.51 1.14 1.14 1.14h17.14a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.14 19H8.71c-.63 0-1.14-.51-1.14-1.14v-3.43a1.14 1.14 0 1 1 2.28 0v2.29h2.29a1.14 1.14 0 1 1 0 2.28M22.43 17.86c-.63 0-1.14-.51-1.14-1.14v-8h-8a1.14 1.14 0 1 1 0-2.28h9.14c.63 0 1.14.51 1.14 1.14v9.14c0 .63-.51 1.14-1.14 1.14M8.71 29.29c-.63 0-1.14-.51-1.14-1.14v-5.71c0-.63.51-1.14 1.14-1.14h8a1.14 1.14 0 1 1 0 2.28H9.85v4.57c0 .63-.51 1.14-1.14 1.14M28.14 29.29c-.29 0-.58-.11-.81-.33L2.19 3.81a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l25.14 25.14a1.14 1.14 0 0 1-.81 1.95Z"
      })]
    })
  }));
};
ReadOnlyViewIcon.displayName = 'ReadOnlyViewIcon';